import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconsUtilityFulfillment = props => {
  if (props.id !== "_svgiconsutilityfulfillment") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.578 3.656a.525.525 0 00-.65-.334l-3.536 1.026a.517.517 0 00-.31.243l-3.367 6.054-6.88-3.633a.52.52 0 00-.269-.065c-.316 0-.705.205-.862.482l-3.218 5.578c-.18.32-.069.87.248 1.057l5.053 2.643a2.734 2.734 0 00-.256 1.155c0 1.567 1.323 2.838 2.955 2.838 1.631 0 2.955-1.27 2.955-2.838 0-.963-.5-1.813-1.264-2.326L17.9 5.246l3.329-.966a.498.498 0 00.349-.624zm-11.092 12.37c1.054 0 1.911.824 1.911 1.836 0 1.013-.857 1.836-1.91 1.836-1.055 0-1.913-.823-1.913-1.836 0-1.012.858-1.836 1.912-1.836z" fill="#202020" /></svg>;
};

SvgIconsUtilityFulfillment.displayName = "_svgiconsutilityfulfillment";
SvgIconsUtilityFulfillment.propTypes = {
  id: PropTypes.string
};
SvgIconsUtilityFulfillment.defaultProps = {
  id: ''
};
export default SvgIconsUtilityFulfillment;